const TimeManager = require('PSTimeManager');

cc.Class({
    extends: cc.Component,

    properties: {
        listeners: {
            type: cc.Component.EventHandler,
            default: []
        }
    },

    start () {
        this._ticker = (date) => { this._tick(date); };
        TimeManager.addListener(this._ticker);
    },

    onDestroy () {
        TimeManager.removeListener(this._ticker);
    },

    _tick (date) {
        this.listeners.forEach((listener) => {
            // eslint-disable-next-line no-underscore-dangle
            const component = listener.target.getComponent(listener._componentName);
            const handler = component[listener.handler];

            handler.call(component, date);
        });
    }

});
